import MailModal from "../../FormsV2/MessageButtons/Modals/MailModal";
import IntlMessages from "../../../util/IntlMessages";
import "./MailContent.less";
import {
   Icon_DoubleLeftCurvyArrow,
   Icon_LeftCurvyArrow,
   Icon_RightCurvyArrow
} from "../../BP2Components/Icons/icons";

interface MailContentButtonsProps {
   mailContent: any;
   previousMail: any;
   previousAttachments: any;
}

const MailContentButtons: React.FC<MailContentButtonsProps> = ({ mailContent, previousMail, previousAttachments }) => {
   return (
      <div className="mail-content__buttons__list">
         <MailModal
            alwaysVisible={true}
            previousMail={previousMail}
            sendMailType="replyAll"
            mailContent={mailContent}
            btnClassName={"mail-content__buttons__list__single mail-replyAll-button"}
            buttonType={"default"}
         >
            <Icon_DoubleLeftCurvyArrow
               fill="none"
               stroke="#64748B"
               className="mail-content__buttons__icon"
            />
            <IntlMessages id="message.replyToAll" />
         </MailModal>
         <MailModal
            alwaysVisible={true}
            previousMail={previousMail}
            sendMailType="reply"
            mailContent={mailContent}
            btnClassName={"mail-content__buttons__list__single mail-reply-button"}
            buttonType={"default"}
         >
            <Icon_LeftCurvyArrow
               fill="none"
               stroke="#64748B"
               className="mail-content__buttons__icon"
            />
            <IntlMessages className="p2" id="message.reply" />
         </MailModal>
         <MailModal
            alwaysVisible={true}
            previousMail={previousMail}
            sendMailType="forward"
            mailContent={mailContent}
            btnClassName={"mail-content__buttons__list__single mail-forward-button"}
            buttonType={"default"}
            previousAttachments={previousAttachments}
         >
            <Icon_RightCurvyArrow
               fill="none"
               stroke="#64748B"
               className="mail-content__buttons__icon"
            />
            <IntlMessages id="message.forward" />
         </MailModal>
      </div>
   );
};

export default MailContentButtons;
